import { put, call, takeLatest, take } from 'redux-saga/effects';

// storage helpers
import * as storage from 'utils/storage';

// store
import { removeUserData, setUserDataRemoved } from '../../actions/authActions';

function* logOut() {
  yield call(storage.clearStorage);
  yield put(setUserDataRemoved());
}

export function* watchLogOut() {
  yield takeLatest(removeUserData.type, logOut);
  yield take(setUserDataRemoved.type);
}
